import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AtendentesComponent } from './atendentes/atendentes.component';
import { EditAtendenteComponent } from './edit-atendentes/edit-atendente.component';
import { EditDevicesAtendenteComponent } from './edit-devices-atendentes/edit-devices-atendente.component';

const routes: Routes = [
  {
    path: '',
    component: AtendentesComponent
  },
  {
    path: 'editar/:id',
    title: 'Editar Atendente',
    component: EditAtendenteComponent
  },
  {
    path: 'editar/devices/:id',
    title: 'Dispositivos do Atendente',
    component: EditDevicesAtendenteComponent
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AtendentesRoutingModule { }